import { Platform } from "react-native";

import { revenueCatProvider } from "./revenuecat";
import { stripeProvider } from "./stripe";
import type { PaymentProvider } from "./types";

export type { PaymentProvider, PlanId, PurchaseResult, PurchaseStatus } from "./types";

/**
 * Resolve the payment provider for the current platform:
 *   - web     → Stripe Checkout
 *   - iOS/Android → native stores via RevenueCat
 */
export function getPaymentProvider(): PaymentProvider {
  return Platform.OS === "web" ? stripeProvider : revenueCatProvider;
}
